import { ErrorBoundaryFallback, ErrorBoundaryRoot } from "./ErrorBoundary";

export const ErrorBoundary = {
  Root: ErrorBoundaryRoot,
  Fallback: ErrorBoundaryFallback,
};
